import { Button, Form, Offcanvas } from "react-bootstrap";
import { categoryServices } from "../../../APIServices/GlobalManagement/BlogManagement/categoryServices";
import { useState } from "react";

const AddNewBlogCategory = ({ Show, Hide, Title, getBlogCategoryList }) => {
  const [loader, setLoader] = useState(false);

  const [name, setName] = useState("");

  const addNewBlogCategory = async () => {
    setLoader(true);
    const userData = {
      name,
    };
    const data = await categoryServices.addNewBlogCategory(userData);
    if (data?.statusCode === 200) {
      setName("");
      getBlogCategoryList();
      Hide();
    }
    setLoader(false);
  };

  return (
    <Offcanvas show={Show} onHide={Hide} placement="end">
      <Offcanvas.Header closeButton className="bg-light p-3 border-bottom">
        <Offcanvas.Title className="fw-bold" style={{ fontSize: 15 }}>
          {Title}
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <Form.Group className="mb-2">
          <Form.Label className="fw-bold mb-1" style={{ fontSize: 13 }}>
            Name
          </Form.Label>
          <Form.Control
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="Enter Name"
            style={{ fontSize: 12 }}
          />
        </Form.Group>
      </Offcanvas.Body>
      <div className="text-end p-2 border-top bg-light">
        <Button
          disabled={!name || loader}
          onClick={addNewBlogCategory}
          variant="outline-primary"
          style={{ fontSize: 13 }}
          className="rounded-2 py-1 px-3"
        >
          {loader ? "Saving..." : Title}
        </Button>
      </div>
    </Offcanvas>
  );
};

export default AddNewBlogCategory;